import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { BASE_TEXT_PX, BLACK_FONT_COLOR, CURSOR, DARK_GRAY_FONT_COLOR, DARK_NAVY_FONT_COLOR, FONT_FAMILY_BOLD, 
    FONT_FAMILY_DEMI, FONT_FAMILY_ITALIC, FONT_FAMILY_REGULAR, GREEN_FONT_COLOR, 
    LARGE_TEXT_PX, LIST_VIEW_TABLE_CELL, ORANGE_FONT_COLOR, RED_FONT_COLOR, SEMANTIC_TEXT_SMALL_PX,
    SEMANTIC_TEXT_XSMALL_PX, SMALL_TEXT_PX, TITLE_FONT_COLOR, UNSET, WHITE_FONT_COLOR, 
    X_SMALL_TEXT_PX, XX_SMALL_TEXT_PX,  PINK_HIGHLIGHT_COLOR, RESERVATION_COLOR, EVENT_INDICATOR_COLOR,
    PARKED_LABEL, STATUS_TEXT, BLACK_FONT_COLOR2 }
     from 'src/styles/fonts/MCFontConstants';     

export const ItemsCardContainer = styled.div.attrs(props => ({
    id: props.id
    }))`
    display: flex;
    background: #ffffff 0% 0% no-repeat padding-box;
    border-radius: 6px;
    margin: ${({ marginOnLargeDevice }) =>
        marginOnLargeDevice ? marginOnLargeDevice : '10px 5px 5px 5px'};
    border: ${({ fullBorder }) => (fullBorder ? fullBorder : '')};
    border-left: ${(props) => props.border.border};
    min-width: ${(props) =>
        props.minWidth.minWidth ? props.minWidth.minWidth : '100%'};
    box-shadow: ${(props) =>
        props.boxShadow ? props.boxShadow : '0px 0px 6px #00000029'};
    width: ${({ width }) => width};
    ${media.mediumDevice`
        margin: ${({ marginOnMediumDevice }) =>
            marginOnMediumDevice ? marginOnMediumDevice : '10px 5px 5px 5px'};
    `}
    ${media.mobileDevice`
        min-width: ${({ itemCardsContainerMinMobWidth }) => (itemCardsContainerMinMobWidth ? itemCardsContainerMinMobWidth : '100%')};
        margin:${({ margin }) => (margin ? margin : '10px 0px')};
        width: ${({ mobileWidth }) => mobileWidth};
    `}
    height: ${({ height }) => (height ? height : '')};
    @media only screen and (min-device-width: 1024px) and (orientation: landscape) and (-webkit-max-device-pixel-ratio: 2) {
        min-width: ${({ enableTemplateCardSpecificStyling }) =>
            enableTemplateCardSpecificStyling && '100%'};
    }
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
        width: ${({ tabWidthPotrait }) => tabWidthPotrait};
    }
`;

export const TextDecoration = styled.div`
    text-decoration: ${({ textdecoration }) => textdecoration};
    -webkit-text-decorations-in-effect: ${({ textdecoration }) =>
        textdecoration};
    -webkit-text-decoration-line: ${({ textdecoration }) => textdecoration};
    -webkit-text-decoration-line: line-through;
    color: ${PINK_HIGHLIGHT_COLOR};
`;

export const WarningTextContainer = styled.span`
    color: ${ORANGE_FONT_COLOR};
    font-size: ${SEMANTIC_TEXT_SMALL_PX};
    font-family: ${FONT_FAMILY_REGULAR};
    display: flex;
    // margin-bottom: 0px;
    // align-items: center;
    padding: ${({ padding }) => (padding ? padding : '')};
`;

export const WarningTextType = styled.div`
    font-size: ${SEMANTIC_TEXT_SMALL_PX};
    color: ${ORANGE_FONT_COLOR};
    font-family: ${FONT_FAMILY_DEMI};
    line-height: 22.59px;
    width: '';
    font-weight: bold;
    display: flex;
    justify-content: flex-start;
    margin-bottom: -3px;
    margin-left: 5px;
    ${media.mobileDevice`
        font-size: ${X_SMALL_TEXT_PX};
   
        `}
`;

export const WarningText = styled.div`
    font-size: ${SEMANTIC_TEXT_SMALL_PX};
    color: ${ORANGE_FONT_COLOR};
    font-family: ${FONT_FAMILY_REGULAR};
    line-height: 22.59px;
    display: flex;
    justify-content: flex-start;
    margin-bottom: -3px;
    margin-left: 5px;
    ${media.mobileDevice`
        font-size: ${X_SMALL_TEXT_PX};
   
        `}
`;

export const TagContainer = styled.div`
    display: flex;
    width: 100%;
    margin-top: -7px;
`;

export const ReservationText = styled.div`
    font-size: 13px;
    color: ${RESERVATION_COLOR};
    font-family: 'AvenirNextWorld Demi';
    line-height: 22.59px;
    font-weight: 600;
    display: flex;
    justify-content: flex-start;
    width: 100%;
`;

export const Flex = styled.div`
    display:${({ display }) => (display ? display : 'flex')};
    height: ${({ height }) => (height ? height : '')};
    width: ${({ width }) => (width ? width : '')}; 
    min-width: ${({ minWidth }) => (minWidth ? minWidth : '')}; 
    justify-content: ${({ justifyContent }) => (justifyContent ? justifyContent : '')};
    flex-direction: ${({ flexDirection }) => (flexDirection ? flexDirection : '')};
    align-items: ${({ alignItems }) => (alignItems ? alignItems : '')};
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '')};
    margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : '')};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '')};
`;

export const Tissue = styled.div`
    margin-top: ${(props) =>
        props.variant === 'productSearch' ? '0px' : '10px'};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '70px')};

    ${media.mobileDevice`
    
    `}
`;

export const NonTissue = styled.div`
    margin-top: 10px;
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '70px')};

    ${media.mobileDevice`
        
    `}
`;

export const CheckBoxContainer = styled.div`
    padding-top: 19px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
`;

export const RowContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    position: ${(props) =>
        props.enableTemplateCardSpecificStyling ? 'relative' : ''};
    padding: ${(props) =>
        props.contentPadding ? props.contentPadding : '15px'};
    width: 100%;
`;

export const ColumnContainer = styled.div`
    display: flex;
    flex-direction: ${(props) =>
        props.flexDirection ? props.flexDirection : 'row'};
    margin-top: ${(props) =>
        props.marginTop ? props.marginTop : '0px'};
    justify-content: ${(props) =>
        props.justifyContent ? props.justifyContent : 'space-between'}; 
    &.setCount {
        color: ${BLACK_FONT_COLOR};
        font-family: ${FONT_FAMILY_REGULAR};
        font-size: ${SMALL_TEXT_PX};
    }
    &.type {
        background: #ebebeb 0% 0% no-repeat padding-box;
        border-radius: 10px;
        display: inline;
        padding-left: 5px;
        padding-right: 5px;
        margin-left: 5px;
    }
`;

export const SetsAndItemsValues = styled.div`
    font-family: ${FONT_FAMILY_REGULAR};
    text-align: left;
    color: ${BLACK_FONT_COLOR};
    margin-left: 0px;
    font-size: ${({ setOrItemDetailsFontSizeDesktop }) =>
        setOrItemDetailsFontSizeDesktop
            ? setOrItemDetailsFontSizeDesktop
            : SMALL_TEXT_PX};
    opacity: 1;
    word-break: break-word;
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '0px'};
    width: ${({ width }) => (width ? width : '')};
    min-width: ${({ minWidth }) => (minWidth ? minWidth : '280px')};
    margin-top: 6px;
    ${media.mobileDevice`
        font-size: ${({ setOrItemDetailsFontSizeMobile }) =>
            setOrItemDetailsFontSizeMobile
                ? setOrItemDetailsFontSizeMobile
                : SEMANTIC_TEXT_SMALL_PX};
        width: ${({ mbWidth }) => (mbWidth ? mbWidth : '')};
    `}
`;

export const ImageContainer = styled.img`
    transform: ${({ isExpanded }) => (isExpanded ? 'rotate(180deg)' : '')};
    cursor: pointer; 
`;

export const CartContainer = styled.div`
    display: ${({ display }) => (display ? display : 'grid')};
    height: ${({ height }) => (height ? height : '')};
    grid-template-columns: 32.25% 32.25% 32.25%;
    width: 100%;
    justify-content: space-between;
    padding: ${({ padding }) => (padding ? padding : '16px 0 0 0')};
    column-gap: ${({ columnGap }) => (columnGap ? columnGap : '15px')};
    row-gap: 15px;
    margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : '')};
    overflow-y: ${({ overflowY }) => (overflowY ? overflowY : '')};
    ${media.mediumDevice`
        grid-template-columns: 49.25% 49.25%;
        column-gap: 10px;
        row-gap: 10px;
    `}
    ${media.smalDevice`
        grid-template-columns: 49.25% 49.25%;
        column-gap: 10px;
        row-gap: 10px;
    `}
    ${media.mobileDevice`
        grid-template-columns: 100%;
    `}

    //ipad Pro(10.5 inch) portrait
    @media only screen and (min-device-width: 834px) and (max-device-width: 834px) and (orientation: portrait) {
        grid-template-columns: 49.25% 49.25%;
    }

    //ipad Pro(10.5 inch) landscape
    @media only screen and (min-device-width: 1112px) and (max-device-width: 1112px) and (orientation: landscape) and (-webkit-max-device-pixel-ratio: 2) {
        grid-template-columns: 32.25% 32.25% 32.25%;
    }
`;

export const LineSeparator = styled.hr`
    border: none;
    border-top: 1px solid #ced4da;
    margin: 8px 0;
    height: 1px;
    width: 100%;
    box-sizing: border-box;
`;

export const SetName = styled.div`
    color: ${(props) => (props.color ? props.color : DARK_NAVY_FONT_COLOR)};
    font-family: ${FONT_FAMILY_DEMI};
    font-size: ${(props) =>
        props.fontSizeDesktop ? props.fontSizeDesktop : LARGE_TEXT_PX};
    cursor: ${(props) => (props.clickable ? 'pointer' : '')};
    ${media.mobileDevice`
        font-size: ${(props) =>
            props.fontSizeMobile ? props.fontSizeMobile : LARGE_TEXT_PX};
    `}
    letter-spacing: ${(props) =>
        props.setNameLetterSpacing ? props.setNameLetterSpacing : 'normal'};
    line-height: ${(props) =>
        props.enableTemplateCardSpecificStyling ? '20px' : 'unset'};
    white-space: ${(props) =>
        props.enableTemplateCardSpecificStyling
            ? props.setNameStyle
                ? 'nowrap'
                : ' break-spaces'
            : 'unset'};
    width: ${({ setNameWidth }) => (setNameWidth ? setNameWidth : '')};
    word-break: ${(props) => (props.setNameBreak ? props.setNameBreak : '')};
    text-overflow: ${({ setNameTextOverflow }) =>
        setNameTextOverflow ? setNameTextOverflow : ''};
    overflow: ${({ setNameOverflow }) =>
        setNameOverflow ? setNameOverflow : ''};
`;

export const SetCount = styled.div`
    color: ${BLACK_FONT_COLOR};
    font-family: ${FONT_FAMILY_REGULAR};
    margin-right: ${({ marginRight }) => (marginRight ? marginRight : '0px')};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : SMALL_TEXT_PX)};
    ${media.mobileDevice`
        margin-right: ${({ mobileMarginRight }) => mobileMarginRight};
    `}
`;

export const Type = styled.div`
    background: #ebebeb 0% 0% no-repeat padding-box;
    border-radius: 10px;
    display: inline;
    padding-left: 6px;
    padding-right: 6px;
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '5px')};
    color: ${DARK_NAVY_FONT_COLOR};
    font-size: ${({ typeFontSize }) => (typeFontSize ? typeFontSize : SEMANTIC_TEXT_SMALL_PX)};
    text-align: center;
    white-space : nowrap;
      margin-right: ${({ marginRight}) => (marginRight ? marginRight : '0px')};
`;

export const ActionButton = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: ${({ enableTemplateCardSpecificStyling, center }) =>
        center
            ? 'center'
            : enableTemplateCardSpecificStyling
            ? 'flex-start'
            : 'center'};
    ${media.mobileDevice``}
`;

export const CardFooter = styled.div`
    display: flex;
    margin: ${({ cartFooterMargin }) =>
        cartFooterMargin ? cartFooterMargin : '5px 0px 0px 0px'};
    justify-content: ${({ justifyContentWithoutBrand }) =>
        justifyContentWithoutBrand ? 'flex-end' : 'space-between'};
    align-items: center;
    align-items: ${(props) =>
        props.enableTemplateCardSpecificStyling ? 'left' : 'center'};
    flex-direction: ${(props) => ( props.mbFlexDirection && props.isEquity ) ? props.mbFlexDirection : 'row'};
    ${media.mobileDevice`
        margin:${(props) =>
            props.enableTemplateCardSpecificStyling
                ? '10px 0px 17px 0px'
                : '5px 0px 12px 0px'};
    `}
    position:${(props) =>
        props.enableTemplateCardSpecificStyling ? 'absolute' : ''};
    bottom: ${(props) => (props.enableTemplateCardSpecificStyling ? '0' : '')};
    width: ${(props) => (props.cardFooterWidth ? props.cardFooterWidth : '')};
`;

export const Brands = styled.div`
    display: flex;
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : FONT_FAMILY_REGULAR};
    text-align: left;
    letter-spacing: ${({ letterSpacing }) =>
        letterSpacing ? letterSpacing : '-0.11px'};
    color: ${({ color }) => (color ? color : BLACK_FONT_COLOR)};
    font-size: ${SEMANTIC_TEXT_SMALL_PX};
    word-break: ${({ wordBreak }) => wordBreak}; 
`;

export const BrandLabel = styled.span`
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : FONT_FAMILY_DEMI}; 
`;
export const WarningDiv = styled.div` 
    marginBottom: '10px';
`;

export const BrandsName = styled.div`
    display: contents;
    text-align: left;
    font-family: ${FONT_FAMILY_REGULAR};
    letter-spacing: ${({ letterSpacing }) =>
        letterSpacing ? letterSpacing : '-0.11px'};
    font-size: ${SMALL_TEXT_PX};
    color: ${({ color }) => (color ? color : BLACK_FONT_COLOR)};
    margin: 0 2px 0 0; 
`;

export const StatusName = styled.div`
    display: block;
    text-align: left;
    font-family: ${FONT_FAMILY_REGULAR};
    letter-spacing: ${({ letterSpacing }) =>
        letterSpacing ? letterSpacing : '-0.11px'};
    font-size: ${SEMANTIC_TEXT_SMALL_PX};
    color: ${({ color }) => (color ? color : BLACK_FONT_COLOR)};
    margin: 0 2px 0 0;
    padding-left: ${({ isEquityOrder }) => (isEquityOrder ? '3px' : '0px')};
`;

export const CounterInput = styled.input.attrs({ type: 'text' })`
    font-family: ${FONT_FAMILY_DEMI};
    border: 2px solid #ececec;
    font-size: ${SEMANTIC_TEXT_SMALL_PX};
    text-align: center;
    margin: auto 9px;
    border-radius: 4px;
    color: ${BLACK_FONT_COLOR};
    opacity: 1;
    height: 35px;
    width: 50px;
    ${media.mobileDevice``}
`;

export const CounterDiv = styled.div`
    font-family: ${FONT_FAMILY_DEMI};
    font-size: ${BASE_TEXT_PX};
    align-items: center;
    margin: ${(props) => (props.margin ? props.margin : 'auto 15px')};
    text-align: center;
    letter-spacing: -0.13px;
    color: ${({ color }) => (color ? color : TITLE_FONT_COLOR)};
    opacity: 1; 
`;

export const AddedText = styled.div`
    color: ${GREEN_FONT_COLOR};
    font-family: ${FONT_FAMILY_REGULAR};
    font-size: ${SEMANTIC_TEXT_XSMALL_PX};
    min-width: 30px;
    margin-right: ${(props) => (props.isLanguageChanged ? '0px' : '10px')};
`;

export const UserAndFavoritesContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;

export const UserNameAndDateContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-right: 157px;
    & .userName {
        letter-spacing: 0;
        text-align: left;
        font-family: ${FONT_FAMILY_DEMI};
        letter-spacing: 0px;
        color: ${DARK_NAVY_FONT_COLOR};
        opacity: 1;
        font-size: ${SMALL_TEXT_PX};
        padding-left: 7px;
        white-space: pre;
    }
    & .dateStamp {
        text-align: left;
        font-family: ${FONT_FAMILY_REGULAR};
        letter-spacing: -0.1px;
        color: ${BLACK_FONT_COLOR};
        opacity: 0.6;
        font-size: ${X_SMALL_TEXT_PX};
        margin-top: -5px;
        padding-left: 7px;
    }
`;

export const FavoriteIconContainer = styled.div`
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 2px #00000029;
    border: 1px solid #ebebeb;
    border-radius: 6px;
    opacity: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    position: ${(props) =>
        props.enableTemplateCardSpecificStyling ? 'absolute' : ''};
    right: ${(props) =>
        props.enableTemplateCardSpecificStyling ? '15px' : ''};
    margin-right: ${({ marginRight }) => (marginRight ? marginRight : '0px')};
    width: ${(props) =>
        props.enableTemplateCardSpecificStyling ? '30px' : ''};
    max-width: ${(props) =>
        props.enableTemplateCardSpecificStyling ? '30px' : ''};
    min-width: ${(props) =>
        props.enableTemplateCardSpecificStyling ? '30px' : ''};
    height: ${(props) =>
        props.enableTemplateCardSpecificStyling ? '30px' : ''};
    bottom: ${(props) =>
        props.enableTemplateCardSpecificStyling && !props.setFavoriteIconTop  
        ? '4px' : 'unset'};
    top: ${(props) =>
        props.enableTemplateCardSpecificStyling && props.setFavoriteIconTop 
        ? '16px' : 'unset'};
`;

export const Icon = styled.img.attrs((props) => ({
    src: props.mobilePath,
}))`
    width: 22px;
    height: 23px;
    cursor: ${(props) => (props.hideCursor ? UNSET : CURSOR)};
    ${media.mobileDevice``}
`;

export const ProductTemplateTitle = styled.div`
    color: ${TITLE_FONT_COLOR};
    font-family: ${FONT_FAMILY_DEMI};
    font-size: ${SMALL_TEXT_PX};
`;

export const StyledTextDiv = styled.div`
    font-family: ${(props) =>
        props.fontFamily ? props.fontFamily : FONT_FAMILY_DEMI};
    font-size: ${(props) => (props.fontSize ? props.fontSize : SEMANTIC_TEXT_SMALL_PX)};
    letter-spacing: ${(props) =>
        props.letterSpacing ? props.letterSpacing : '0px'};
    color: ${(props) => (props.color ? props.color : LIST_VIEW_TABLE_CELL)};
    opacity: ${(props) => (props.opacity ? props.opacity : 1)};
    padding: ${(props) => props.padding};
    text-align: ${(props) => props.textAlign};
    margin-left: ${(props) => props.marginLeft};
    margin-right: ${(props) => props.marginRight};
    text-decoration: ${(props) => props.textDecoration};
    font-weight: ${(props) => (props.fontWeight ? props.fontWeight : 'normal')};
    width: ${(props) => props.width};
    min-width: ${(props) => props.minWidth};
    @media screen and (min-width: 768px) and (max-width: 768px) and (orientation: portrait){
     margin-left: ${({ ipadMarginLeft }) => (ipadMarginLeft ? ipadMarginLeft : '')};
     width:${({ iPadwidth }) => (iPadwidth ? iPadwidth : '')};

    }
`;

export const ProductTemplateDetailsHeader = styled.div`
    letter-spacing: 0;
    text-align: left;
    font-family: ${FONT_FAMILY_DEMI};
    letter-spacing: 0px;
    color: ${DARK_NAVY_FONT_COLOR};
    opacity: 1;
    font-size: ${SMALL_TEXT_PX};
    white-space: pre;
    margin-top: 20px;
`;

export const NoShipText = styled.label`
    font-size: ${X_SMALL_TEXT_PX};
    color: ${EVENT_INDICATOR_COLOR};
    font-family: ${FONT_FAMILY_DEMI};
    margin: ${({ margin }) => margin};
`;

export const SetLocatedText = styled.label`
    font-size: ${SMALL_TEXT_PX};
    color: ${DARK_GRAY_FONT_COLOR};
    font-family: ${FONT_FAMILY_DEMI};
    margin-top: 5px;
`;

export const SetLocatedRowDiv = styled.div`
    display: flex;
    flex-direction: row;
    align-items: ${({ alignItem }) => (alignItem ? alignItem : 'flex-start')};
    margin-bottom: 5px;
`;

export const BatchText = styled.div`
    color: ${BLACK_FONT_COLOR2};
    font-size: ${SMALL_TEXT_PX};
    font-family: ${FONT_FAMILY_REGULAR};
    width: ${(props) => props.width};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const ParkedLabel = styled.label`
    font-size: ${XX_SMALL_TEXT_PX};
    border: 1px solid #008d00;
    padding: 2px;
    border-radius: 10px;
    background: #cbffd2;
    width: 50px;
    text-align: center;
    color: ${PARKED_LABEL};
`;

export const AllocatedText = styled.label`
    color: ${BLACK_FONT_COLOR2};
    font-size: ${XX_SMALL_TEXT_PX};
    font-family: ${FONT_FAMILY_REGULAR};
`;

export const RedCircle = styled.div`
    height: 10px;
    width: 10px;
    background-color: ${RED_FONT_COLOR};
    border-radius: 5px;
    margin-right: 2px;
    color: ${WHITE_FONT_COLOR};
    font-size: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 3.5px;
`;

export const PhysicianAndAccount = styled.div`
    display: flex;
    flex-direction: column;
    margin: 5px 0 0 0;
`;

export const Account = styled.div`
    display: flex;
    flex-direction: ${(props) =>
        props.flexDirection ? props.flexDirection : 'row'};
    flex-wrap: nowrap;
    min-width: 0;
`;

export const AccountName = styled.p`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0;
    font-size: ${SMALL_TEXT_PX};
    font-family: ${FONT_FAMILY_REGULAR};
    max-width: ${({ truncate }) => (truncate ? '62%' : 'unset')};
`;

export const AccountId = styled.div`
    display: flex;
    flex-shrink: 0;
    font-family: ${FONT_FAMILY_ITALIC};
    font-size: ${SMALL_TEXT_PX};
    margin: 0 0 0 5px;
`;

export const Physician = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    min-width: 0;
`;

export const PhysicianName = styled.p`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0;
    font-size: ${SMALL_TEXT_PX};
    font-family: ${FONT_FAMILY_REGULAR};
    max-width: ${({ truncate }) => (truncate ? '62%' : 'unset')};
`;

export const PhysicianId = styled.div`
    display: flex;
    flex-shrink: 0;
    font-family: ${FONT_FAMILY_ITALIC};
    font-size: ${SMALL_TEXT_PX};
    margin: 0 0 0 5px;
`;

export const Parked = styled.div`
    color: ${PARKED_LABEL};
    font-family: ${FONT_FAMILY_DEMI};
    font-size: ${XX_SMALL_TEXT_PX};
    border: 0.5px solid #00610099;
    background: #cbffd2;
    width: 20%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 17px;
    height: 18px;
`;

export const AddedCartButton = styled.div`
    width: ${({ width }) => (width ? width : '30px')};
    height: ${({ height }) => (height ? height : '30px')};
    display: flex;
    justify-content: center;
    background-color: white;
    align-items: center;
    border: ${({ border }) => (border ? border : '1px solid #ebebeb')};
    box-shadow: 0px 0px 2px #00000029;
    border-radius: 6px;
    opacity: 1;
    &.disabled {
        opacity: 0.5;
        pointer-events: none;
    }
`;

export const AddCartIcon = styled.img.attrs((props) => ({
    src: props.mobilePath,
}))`
    width: ${({ width }) => (width ? width : '14px')};
    height: ${({ height }) => (height ? height : '14px')};
    cursor: pointer;
`;

export const MoreItemView = styled.div`
    margin: 2.25px 0px 0px 8px;
    color: ${TITLE_FONT_COLOR};
    font-size: ${SEMANTIC_TEXT_XSMALL_PX};
    font-family: ${FONT_FAMILY_REGULAR};
    cursor: pointer;
`;

export const AccountAndID = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    min-width: 0;
`;

export const StatusText = styled.div`
    font-family: ${FONT_FAMILY_BOLD};
    float: right;
    font-size: ${XX_SMALL_TEXT_PX};
    letter-spacing: -0.1px;
    color: ${STATUS_TEXT};
    width: ${({ width }) => (width ? width : '50px')};
    text-align: center;
    font-weight: bold;
    border-radius: 3px;
    ${media.mobileDevice``}
`;

export const Status = styled.div`
    display: flex;
    justify-content: center;
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '')};
    margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : '')};
    height: 21px;
    width: ${({ width }) => (width ? width : '59px')};
    margin-left: 35px;
    background: #f2efff 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
    align-items: center;
    text-align: center;
    ${media.mobileDevice`
        border-radius: 4px;
    `}
`;

export const InputBox = styled.input`
    height: 40px;
    width: 86px;
    background: #ffffff 0% 0% no-repeat padding-box;
    border: ${({ error }) =>
        error ? '1px solid #ED002A66' : '2px solid #ebeded'};
    border-radius: 6px;
    opacity: 1;
    text-align: center;
    &:focus {
        outline: none;
    }
    ${media.mobileDevice`
    width: 48px;
    height:38px;
    margin-top: -6px;
    margin-right: ${({ marginRight }) => marginRight ? marginRight : '0px'};
    `}
`;

export const EAStatus = styled.div`
    height: 21px;
    font-family: ${FONT_FAMILY_REGULAR};
    background: #ebebeb 0% 0% no-repeat padding-box;
    border-radius: 11px;
    opacity: 1;
    align-items: center;
    text-align: center;
    padding: 0px 1px 2px 1px;
    ${media.mobileDevice`
        border-radius: 4px;
    `}
`;

export const EAStatusText = styled.div`
    font-family: ${FONT_FAMILY_REGULAR};
    font-size: ${({ fontSize }) => fontSize ? fontSize : SEMANTIC_TEXT_SMALL_PX};
    letter-spacing: -0.1px;
    color: ${DARK_NAVY_FONT_COLOR};
    width: auto;
    white-space: nowrap;
    text-align: center;
    opacity: 1;
    padding: 0 5px; 
`;

export const StatusTextBundle = styled.div`
    font-family: 'AvenirNextWorld bold';
    float: right;
    font-size: 10px;
    letter-spacing: -0.1px;
    color: #654adc;
    //height: 17px;
    width: 50px;
    text-align: center;
    font-weight: bold;
    border-radius: 3px;
    ${media.mobileDevice`     
     
    `}
`;

export const StatusBundle = styled.div`
    display: flex;
    justify-content: center;
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '')};
    margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : '')};
    height: 21px;
    width: 59px;
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '35px')};
    background: #f2efff 0% 0% no-repeat padding-box;
    border-radius: 4px;

    opacity: 1;
    align-items: center;
    text-align: center;
    ${media.mobileDevice`
        border-radius: 4px;
    `}
`;
